import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';

@Injectable({
  providedIn: 'root'
})
export class FaltaService {

  public params = new HttpParams();

  constructor(
    private readonly apiService: ApiService
  ) {}

  /**
   * Lista faltas com filtros opcionais.
   *
   * Endpoint:
   * GET /api/Falta
   */
  list(params?: any): Observable<any> {

    const httpParams = params
      ? new HttpParams({
          fromObject: params
        })
      : this.params;

    return this.apiService.get(
      '/api/Falta',
      httpParams
    );
  }
}